var Model = require("./model.js");
var StateMachine = require("./stateMachine.js");
var logError = require("./error.js");
var Collections = require("./src/collections/index.js");
var TreeNode = require("./treeNode.js");
var mixin = require("./src/general.js").mixin;
var GuiEvents = require("./event.js").GuiEvents;

var DataRoot = require("./src/datamodel/dataRoot.js");
var ModelRoot = require("./src/datamodel/modelRoot.js");



/**
 *  Base class of a Controller. All the controllers should extend this class.
 *
 * @constructor
 */
var Controller = function(archLayers, dependencies, configuration) {
    this.makeTreeNode();

    this.archLayers = archLayers;
    this.dependencies = dependencies;

    this.root = this.archLayers.root; //todo should probably be removed
    this.rootModel = this.archLayers.rootModel; //todo should probably be removed
    this.rootStateMachine = this.archLayers.rootStateMachine; //todo should probably be removed

    this.configuration = this.defaultConfiguration || {};
    for (var key in configuration) {
        if (configuration.hasOwnProperty(key)) {
            this.configuration[key] = configuration[key];
        }
    }

    this.beforeLoadActions = new Collections.List();
    this.afterLoadActions = new Collections.List();

    this.defaultConfiguration = {};   //to be overriden by the controller if any defaults for the manifest options should be applied
};
mixin(Controller, TreeNode);

Controller.prototype.setDefaultConfiguration = function(defaultConfiguration) {
    if (!this.defaultConfiguration) this.defaultConfiguration = {};

    for (var key in defaultConfiguration) {
        if (defaultConfiguration.hasOwnProperty(key)) {
            this.defaultConfiguration[key] = defaultConfiguration[key];
        }
    }
};

Controller.buildApp = function(editorHolder, config, documentClass, dataClass) {

    var root = new DataRoot(); // TODO: This doesn't belong here!

    if (dataClass) {
        // var doc = new documentClass(root);
        var data = new dataClass(true);
        // doc.body(data);
        root.attachData(data);
    }

    root.editorHolder = editorHolder; //TODO we should have a base View

    var modelRoot = new ModelRoot();
    var model = new Model();
    modelRoot.attachData(model);

    var rootStateMachine = new StateMachine();
    rootStateMachine.root = root;


    var archLayers = {root : root, rootModel : model, rootStateMachine : rootStateMachine};
    var top_controller = Controller.construct("top", config, archLayers);

    top_controller.resolveDependencies_rec();

    var promise = top_controller.load(config,1);

    GuiEvents.addEvents({
        APP_LOADED: {id: 'ctrl_1', name: "APP_LOADED" }
    });

    return promise.then(function(){
        top_controller.rootStateMachine.append(top_controller.name(), top_controller.getStatemachine(), "idle", null, "idle", null, null);
        top_controller.executeAfterBuild();
        top_controller.afterBuild();
        rootStateMachine.handle(GuiEvents.APP_LOADED);
        return top_controller;
    });
};


Controller.destroyApp = function(toplevelController) {
    delete window['CircuitsRecorder'];
    delete window.errorMessageModel;
    $(window).off();
};

Controller.construct = function (name, config, archLayers) {
    if (Controller.DEBUG) console.log("Constructing: ", name );

    console.assert(config.controller, name + ": Config should define a controller!");

    for (var prop in config) {
        if (config.hasOwnProperty(prop)) {
            console.assert(["name", "controller", "configuration", "extensions", "disabled"].indexOf(prop) !== -1 , "Config should NOT define a property " + prop + " in "+ name +"!");
        }
    }

    var controller = new config.controller(archLayers, {}, config.configuration);
    controller._name = name;

    var extensions = config.extensions;
    for (var ext_name in extensions) {
        if (extensions.hasOwnProperty(ext_name)) {
            var ext_config = extensions[ext_name];
            if(!ext_config.disabled){
                var ext_controller = Controller.construct(ext_name, ext_config, archLayers);
                ext_controller.parent(controller);
            }
        }
    }
    return controller;

};

Controller.prototype.resolveDependencies_rec = function() {
    if (Controller.DEBUG) console.log("resolving dependencies: ", this.name() );

    this.resolveDependencies();

    this.children.forEach(function(key, child){
        child.resolveDependencies_rec();
    });

};

Controller.prototype.resolveDependencies = function() {
    var upstream_dependency_declaration = this.constructor.inject;
    var downstream_dependency_declaration = this.constructor.deject;

    var dependencies = {};
    for (var key in upstream_dependency_declaration) {
        if (upstream_dependency_declaration.hasOwnProperty(key)) {
            var dependency = this._findUpstream(upstream_dependency_declaration[key]);
            if (dependency !== null) {
                dependencies[key] = dependency;
            } else {
                console.warn("Unresolved upstream dependency! " + key)
            }
        }
    }
    for (var key in downstream_dependency_declaration) {
        if (downstream_dependency_declaration.hasOwnProperty(key)) {
            var dependency = this.findDownstream(downstream_dependency_declaration[key]);
            if (dependency !== null) {
                if (dependency.length && dependency.length === 1) {
                    dependencies[key] = dependency[0];
                } else {
                    dependencies[key] = dependency; //Array of dependencies
                }

            } else {
                console.warn("Unresolved downstream dependency! " + key)
            }
        }
    }
    this.dependencies = dependencies;

    for (key in dependencies) {
        if (dependencies.hasOwnProperty(key)) {
            this[key] = dependencies[key];
        }
    }
};

/**
 *  Called after the entire build is done. Can be used to initialize the app after
 *  the entire rootStateMachine is available
 */
Controller.prototype.executeAfterBuild = function () {
    var self = this;
    this.children.forEach(function (key, child) {
        child.afterBuild();
        child.executeAfterBuild();
    });
};

Controller.prototype.afterBuild = function () {
    // to be implemented by child classes
};

/**
 *  Called before extensions are loaded. Mainly to setup the model/data/view for now.
 *
 */
Controller.prototype.beforeLoadPromise = function() {
    var self = this;

    self.log("beforeLoadPromise: "+ self.name());

    var promise = new Promise(function(resolve, reject) {
        var returnval = self.beforeLoad();
        console.assert(typeof(returnval) !== "boolean",
                "beforeLoad of " + self.name() + " did return a boolean");
        resolve("Stuff worked!");
    });

    return promise;
};


Controller.prototype.beforeLoad = function() {
    var self = this;

    self.log(self.name() + " beforeLoad");

    // execute all beforeload actions
    self.beforeLoadActions.forEach(function (idx, action) {
        action(self);
    });

    self.assignModelAndData();
    self.assignGuiHolder();
};


/**
 *  Called after extensions are loaded. Mainly to append statemachine for now.
 */
Controller.prototype.afterLoadPromise = function() {
    var self = this;

    self.log( "afterLoadPromise: "+ self.name());

    var promise = new Promise(function(resolve, reject) {
        var returnval = self.afterLoad();
        console.assert(typeof(returnval) !== "boolean",
                "afterLoad of " + self.name() + " did return a boolean");
        resolve("Stuff worked!");
    });

    return promise;
};

Controller.prototype.afterLoad = function() {
    var self = this;

    self.log( self.name() + " afterLoad");

    // execute all afterload actions
    self.afterLoadActions.forEach(function (idx, action) {
        action(self);
    });

    self.appendToParentSM();
};

/**
 *  Load the model/data/view, load extensions if any and finally append the statemachine.
 *  It's intended for internal use only, only the root controller needs to call load().
 *
 * @param {Integer} level The depth of the extension scope, default is 1
 */
Controller.prototype.load = function(level) {
    var self = this;

    self.level = level;

    return self.beforeLoadPromise()
        .then(function () {
            return self.loadExtensionsPromise();
        }).then(function () {
            return self.afterLoadPromise();
        });
};

/**
 *  Load extensions if any. Call the load function of each extension to recursively load the children extensions.
 *
 * @param {Integer} level The depth of the extension scope, default is 1
 */

Controller.prototype.loadExtensionsPromise = function () {

    var loadPromises = [];
    this.children.forEach(function(key, child){
        loadPromises.push(child.load.bind(child,1));
    });

    return allPromisesInOrder(loadPromises);
};


var allPromisesInOrder = function(promises) {
    return new Promise(function(resolve, reject) {
        if(promises.length === 0)
            resolve();
        else
            resolve(
                promises[0]()
                .then(function() {
                    return allPromisesInOrder(promises.slice(1));
                })
            );
    });
};

/**
 *  Assign the this.guiholder with either the current controller's view.$el or reuse parent's guiholder
 */
Controller.prototype.assignGuiHolder = function() {
    if (this.getView()) {
        this.guiholder = this.getView().$el;
    } else {
        if (this.parent())
            this.guiholder = this.parent().guiholder;
    }
    return true;
};

/**
 *  Assign the model and data. When there is new data in the current controller, register the data instance so that
 *  when later the data is being injected, it will use the saved data.
 */
Controller.prototype.assignModelAndData = function() {
    var parent = this.parent();

    var parentModel = null;
    if (parent) {
        parentModel = parent.getModel();
    } else {
        parentModel = this.rootModel;
    }

    // set the default scope of this extension (=path)
    this.getModel().scope(this.getPath());

    // add the model in the tree
    parentModel.submodel.put(this.name(), this.getModel());

    return true;
};

/**
 *  Append this.stateMachine to parent.stateMachine. autoAppendArgs is used to set the appending parameters.
 */
Controller.prototype.appendToParentSM = function() {
    if (this.autoAppendArgs == null) {
        this.autoAppendArgs = ["idle", null, "idle", null, null]
        this.log( this.name() + " use default autoAppendArgs");
        }
    var enter, enter_func, exit, exit_func, merge, ref;
    if (!this.parent() || !this.parent().getStatemachine() || !this.getStatemachine()) {
        this.log( this.name() + " missing: stateMachine");
        return false;
    }
    ref = this.autoAppendArgs, enter = ref[0], enter_func = ref[1], exit = ref[2], exit_func = ref[3], merge = ref[4];
    this.parent().getStatemachine().append(this.name(), this.getStatemachine(), enter, enter_func, exit, exit_func, merge);
    return true;
};

/**
 * Returns the current extensions stateMachine. Creates one on the first time
 * it is called.
 */
Controller.prototype.getStatemachine = function() {
    if (!this.stateMachine) {
        this.stateMachine = this.createStateMachine();
    }
    return this.stateMachine;
};

/**
 * Returns the current extensions model. Creates one on the first time
 * it is called.
 */
Controller.prototype.getModel = function() {
    if (!this.model) {
        this.model = this.createModel();
    }
    return this.model;
};

/**
 * Returns the current extensions view. Creates one on the first time
 * it is called.
 */
Controller.prototype.getView = function() {
    if (!this.view) {
        this.view = this.createView();
    }
    return this.view;
};

/**
 * Returns the path of the current extension in the extension tree
 */
Controller.prototype.getPath = function () {
    var path = this.name();
    var parent = this.parent();
    while (parent) {
        path = parent.name() + "/" + path;
        parent = parent.parent();
    }
    return path;
};

Controller.prototype.name = function() {
    return this._name;
};

/**
 * This function should be overriden in the controller to return a new extension
 * StateMachine. If it is not overriden, an empty stateMachine is created for
 * this controller.
 */
Controller.prototype.createStateMachine = function () {
    // has to be implemented by child classes
    return new StateMachine();
};

/**
 * This function should be overriden in the controller to return a new extension
 * model. If it is not overriden, an empty model is created for this controller.
 */
Controller.prototype.createModel = function () {
    // can be implemented by child classes to implement specific model behavior
    if (this.root)
        return new Model();
    else
        return null;
};

/**
 * This function should be overriden in the controller to return a new extension
 * view
 */
Controller.prototype.createView = function () {
    // can be implemented by child classes
};

/**
 * Adds a function just before the afterLoad phase of this extension
 * @param {function()} action Action function to be added
 */
Controller.prototype.addAfterLoadAction = function (action) {
    this.afterLoadActions.push(action);
};

Controller.prototype.log = function(str) {
    if (Controller.DEBUG) console.log(Controller.indent.repeat(this.level) +str);
};


/**
 * Adds a function just before the beforeLoad phase of this extension
 * @param {function()} action Action function to be added
 */
Controller.prototype.addBeforeLoadAction = function (action) {
    this.beforeLoadActions.push(action);
};

Controller.indent = "--";

String.prototype.repeat = function(count) {
    if (count < 1) return '';
    var result = '', pattern = this.valueOf();
    while (count > 1) {
        if (count & 1) result += pattern;
        count >>= 1, pattern += pattern;
    }
    return result + pattern;
};

Controller.DEBUG = false;

module.exports = Controller;
